/*
 * Author: Dw
 * File Created: Tuesday, 25-03-11 05:20 pm
 * Last Modified: Wednesday, 25-03-12 10:48 am, by Dw
 */

function CheckBoxSquareUnChecked() {
  return <svg viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" data-sentry-element="svg" data-sentry-component="CheckBoxSquareUnChecked" data-sentry-source-file="index.tsx">
      <rect x="2.5" y="2.5" width="15" height="15" rx="1.5" stroke="currentColor" data-sentry-element="rect" data-sentry-source-file="index.tsx" />
    </svg>;
}
export default CheckBoxSquareUnChecked;